import { ExpirationInterval, ExpirationType } from "@/graphql";

export type Expiration =
  | { type: ExpirationType.NoExpiration }
  | {
      type: ExpirationType.Relative;
      value: number;
      interval: ExpirationInterval;
    }
  | { type: ExpirationType.Absolute; value: string };

export const intervals = {
  [ExpirationInterval.Day]: "days",
  [ExpirationInterval.Week]: "weeks",
  [ExpirationInterval.Month]: "months",
  [ExpirationInterval.Year]: "years",
};

export type Preview = {
  name: string;
  description: string;
  expiration: Expiration;
};
